import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { IonicPage,ModalController, NavParams,ViewController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
@IonicPage()
@Component({
  selector: 'page-select-rating',
  templateUrl: 'select-rating.html',
})
export class SelectRatingPage {


  dataList = [];
  dataSet:any = {};
  templateList:any = [];
  consequenceId:any = null;
  likelihoodId:any = null;
  riskLevel:any = null;
  riskData:any = {};
  colourCode:any = null;
  currentGroup:any = null;
  risk_matrixList: any = [];
  constructor(
    private api: CrudProvider, public utiltiy: UtiltiyProvider,
    private modal: ModalController,
    public nvmPrms: NavParams,
    public viewCtrl :ViewController,
  ) { 
   let data = nvmPrms.get('data');
   this.dataSet = data;
  console.log("data",data)
  }
  
  
  ionViewDidLoad() {
    this.getMetaData();
  }

  async getMetaData(){
    this.currentGroup = await this.utiltiy.getStorage("currentClass");
    this.utiltiy.startLoading();
    let consequenceList = await this.getData("get_consequence_list");
    let likelihoodList = await this.getData("get_likelihood_list");
     this.risk_matrixList = await this.getData("risk_matrix");
    this.combineList(consequenceList,likelihoodList)
    this.utiltiy.stopLoading();
    console.log("1",consequenceList);
    console.log("2",likelihoodList);
    console.log("3",this.risk_matrixList);
  }

  combineList(consequenceList,likelihoodList){
    consequenceList = consequenceList.reverse();
    likelihoodList = likelihoodList.reverse();
    consequenceList.forEach(element => {
      element.value = null
    });
    likelihoodList.forEach(element => {
      element.value = null
    });

    this.templateList = [
      {
        "name":"Consequence",
        "children": consequenceList,
      },
      {
        "name":"Likelihood",
        "children": likelihoodList,
      }
    ];

    console.log("   this.templateList",   this.templateList)

  }

  rattingCliked(i,j){
    if(i == 0){
     this.consequenceId = this.templateList[i].children[j].TakeFive_Consequence_Code;
     this.templateList[i].name = "Consequence "+this.consequenceId;
    }else if(i == 1){
      this.likelihoodId = this.templateList[i].children[j].TakeFive_Likelihood_Code;
      this.templateList[i].name = "Likelihood "+this.likelihoodId;
    }

    if(this.consequenceId && this.likelihoodId){
      this.getRiskRating();
    }

  }

  getRiskRating(){
    let riskLevel :any= {};
    this.risk_matrixList .forEach(element => {
      if(element.Take_5_Risk_Matrix_Consequence == this.consequenceId && element.Take_5_Risk_Matrix_Likelihood == this.likelihoodId){
        // this.riskLevel
        riskLevel = element;
      }
      
    });

    let alphabet = "abcdefghijklmnopqrstuvwxyz";

    let Likelihoodindex = alphabet.indexOf(riskLevel.Take_5_Risk_Matrix_Likelihood.toLowerCase())+1;
    let consequenceindex = parseFloat(riskLevel.Take_5_Risk_Matrix_Consequence);

    console.log("Likelihoodindex",Likelihoodindex);
    console.log("consequenceindex",consequenceindex);


    this.riskLevel = riskLevel.Take_5_Risk_Matrix_Rating;
    this.riskData = riskLevel;
    if(Likelihoodindex >= consequenceindex){
      this.getColourCode(consequenceindex);

    }

    if(consequenceindex >= Likelihoodindex){
      this.getColourCode(Likelihoodindex);
    }
    console.log(Likelihoodindex,"riskLevel",riskLevel)
  }
  

  getColourCode(i){
    let code = null;
    switch (i) {
      case 1:
        code = '#28a745';
       break;
      case 2:
        code = ' #f1c231';
        break;

      case 3:
        code = '#b1651c';
        break;

      case 4:
        code = '#dc3545';
       break;
    
      default:
        code = '#b71464'
        break;
    }
    console.log("i",i)
    this.colourCode = code;
    this.riskData.colourCode = code;
  }

  async getData(method){
    let formData: FormData = new FormData();
    formData.append("method_name", method);
    let apiUrl =  this.currentGroup == 'klmr'?'/prestart/take_5/Add_Templates':'/tansix_prestart/take_5/Add_Templates';
    return this.api.post(apiUrl, false,formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          return result.result;
        }else{
         return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

}

templatetoggleSection(i){
  this.templateList[i].open = !this.templateList[i].open;
}

templatetoggleItem(i,j){
  this.templateList[i].children[j].open = ! this.templateList[i].children[j].open;
}
  
  onSearch(event) {
   
  }

  saveRating(){
    this.riskData.type = this.dataSet.type;
    this.viewCtrl.dismiss(this.riskData);

  }
  
  
  onClose(item?) {
    this.viewCtrl.dismiss(item);
  }
  
  dismiss(){
    this.viewCtrl.dismiss(false);
  
  }
  }


// WEBPACK FOOTER //
// ./src/pages/select-rating/select-rating.ts